/**
 * サイドバーの開閉ボタンを追加
 */
export function sidebarCollapse() {
    const body = document.body;
    if (body.classList.contains('preview-screen')) {
        return;
    }

    if (window.top !== window) {
        return;
    }

    const btn = document.createElement('button');
    btn.id = 'mtapp-sidebar-collapse';
    btn.type = 'button';
    btn.innerHTML = `
        <svg title="Full Screen" role="img" class="mt-icon">
            <use xlink:href="${window.mtappVars.static_path}images/sprite.svg#ic_fullscreen" />
        </svg>`;

    btn.addEventListener('click', function () {
        const elementsToToggle = document.querySelectorAll('.mt-secondaryPanel,.mt-primaryNavigation,.mt-secondaryPanel--scrollable');
        elementsToToggle.forEach((element) => {
            element.classList.toggle('d-none');
        });
    });

    body.appendChild(btn);
}
